<template>
  <div
    class="video-about">
    <video-pulse-play
      class="video-about__play"
      @click.native="showVideo" />
    <div class="video-about__title">
      How we try hard
    </div>
    <div class="video-about__subtitle">
      Watch the video about SkyCoach
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import VideoPulsePlay from './VideoPulsePlay.vue';

export default {
  name: 'VideoAbout',

  components: { VideoPulsePlay },

  methods: {
    ...mapActions(['showVideo']),
  },
};
</script>

<style lang="scss" scoped>
  .video-about {
    display: grid;
    align-items: center;
    grid-template-columns: 28px 1fr;
    grid-template-rows: auto auto;
    grid-gap: 3px 20px;
    position: relative;
  }

  .video-about__title {
    font-weight: 500;
    font-size: 15px;
    align-self: end;
  }

  .video-about__subtitle {
    font-weight: 300;
    font-size: 13px;
    align-self: start;
  }

  .video-about__play {
    width: 28px;
    height: 28px;
    grid-row: 1 / -1;
    font-size: 9px;
  }

  @media screen and #{$screen-more-or-1024} {
    .video-about {
      grid-template-columns: 40px 1fr;
      margin-top: 0;
      grid-gap: 4px 20px;
    }

    .video-about__title {
      font-size: 19px;
      line-height: 23px;
    }

    .video-about__play {
      width: 40px;
      height: 40px;
      font-size: 12px;
    }

    .video-about {
      grid-column-gap: 35px;
    }
  }
</style>
